import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import ScrollTop from '../../components/scroll-top';
import {convertPipeToBrTag} from "../../utils";

/**
 * HomePage
 */
const HomePage = ({
                    containerId,
                    containerClass,
                    hideScrollTop,
                    pageName,
                    pcHeading,
                    mbHeading,
                    header,
                    hero,
                    children,
                    footer,
                    ctaNavi,
                    anchorNavi,
                    cookieEditor,
                  }) => {
  const getPcHeading = () => {
    if (pcHeading !== null) {
      return pcHeading;
    } else {
      if (mbHeading !== null) {
        return mbHeading;
      }
    }
    return (pageName !== null) ? pageName: '';
  };
  const getMbHeading = () => {
    if (pcHeading !== null) {
      if (mbHeading !== null) {
        return mbHeading;
      } else {
        return pcHeading;
      }
    } else {
      if (mbHeading !== null) {
        return mbHeading;
      }
    }
    return (pageName !== null) ? pageName: '';
  };
  //
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <div className="HomePage">
        {(header !== null) ? <header className="HomePage__header">{header}</header>: null}
        <main className="HomePage__main">
          {(hero !== null) ? hero: null}
          <h1 className="HomePage__heading">
                        <span className="HomePage__heading-pc">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcHeading())}}/>
                        </span>
            <span className="HomePage__heading-mb">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbHeading())}}/>
                        </span>
          </h1>
          {(children !== null) ? children: null}
        </main>
        {(footer !== null) ? <footer className="HomePage__footer">{footer}</footer>: null}
        {(hideScrollTop === false) ? <ScrollTop/>: null}
        {(ctaNavi !== null) ? ctaNavi: null}
        {(anchorNavi !== null) ? anchorNavi: null}
        {(cookieEditor !== null) ? cookieEditor: null}
      </div>
    </Wrapper>
  )
};
HomePage.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  hideScrollTop: PropTypes.bool,
  pageName: PropTypes.string,
  pcHeading: PropTypes.string,
  mbHeading: PropTypes.string,
  header: PropTypes.arrayOf(PropTypes.node),
  hero: PropTypes.arrayOf(PropTypes.node),
  children: PropTypes.arrayOf(PropTypes.node),
  footer: PropTypes.arrayOf(PropTypes.node),
  ctaNavi: PropTypes.arrayOf(PropTypes.node),
  anchorNavi: PropTypes.arrayOf(PropTypes.node),
  cookieEditor: PropTypes.arrayOf(PropTypes.node),
};
HomePage.defaultProps = {
  containerId: null,
  containerClass: null,
  hideScrollTop: null,
  pageName: null,
  pcHeading: null,
  mbHeading: null,
  header: null,
  hero: null,
  children: null,
  footer: null,
  ctaNavi: null,
  anchorNavi: null,
  cookieEditor: null,
};
export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/home-page/index.jsx